<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <path fill="none" d="M149.593,64.624l-14.808-14.807c-2.22-2.228-5.825-2.234-8.053-0.014c-0.005,0.005-0.01,0.009-0.014,0.014
      l-7.713,7.712l22.875,22.875l7.712-7.712c2.228-2.22,2.233-5.826,0.014-8.054C149.602,64.633,149.598,64.629,149.593,64.624z"/>
    <path fill="none" d="M112.262,64.273l-61.951,61.951l-2.847,25.722l25.722-2.848L135.1,87.186L112.262,64.273z M75.875,129.643
      c-1.878,1.895-4.937,1.908-6.832,0.029c-1.894-1.877-1.908-4.936-0.029-6.83l40.855-40.236c1.877-1.896,4.936-1.908,6.83-0.03
      s1.908,4.937,0.029,6.831L75.875,129.643z"/>
    <path class="color" fill="#F45B5B" d="M116.699,82.575c-1.895-1.878-4.953-1.865-6.83,0.03l-40.855,40.236c-1.878,1.895-1.865,4.953,0.029,6.83
      c1.895,1.879,4.953,1.865,6.832-0.029l40.854-40.236C118.607,87.512,118.594,84.453,116.699,82.575z"/>
    <path class="color" fill="#F45B5B" d="M156.284,57.885l-14.76-14.759c-0.007-0.008-0.014-0.015-0.021-0.021
      c-5.938-5.925-15.553-5.916-21.478,0.021L109.183,53.97c-0.085,0.074-0.18,0.132-0.261,0.213c-0.082,0.081-0.14,0.175-0.214,0.261
      l-66.322,66.322c-0.761,0.751-1.246,1.738-1.376,2.8l-3.654,33.221c-0.021,0.183-0.03,0.366-0.029,0.551
      c0.016,2.621,2.153,4.733,4.774,4.717l0.569-0.047l33.221-3.654c1.062-0.131,2.048-0.615,2.8-1.377l66.288-66.287
      c0.08-0.07,0.172-0.125,0.248-0.201c0.01-0.009,0.019-0.018,0.027-0.027c0.077-0.078,0.131-0.168,0.202-0.25l10.828-10.828
      c0.007-0.006,0.015-0.014,0.021-0.021C162.23,73.425,162.221,63.81,156.284,57.885z M73.186,149.099l-25.722,2.848l2.847-25.722
      l61.951-61.951L135.1,87.186L73.186,149.099z M149.593,72.692l-7.712,7.712l-22.875-22.875l7.713-7.712
      c0.004-0.004,0.009-0.009,0.014-0.014c2.228-2.22,5.833-2.214,8.053,0.014l14.808,14.807c0.005,0.005,0.009,0.009,0.014,0.014
      C151.826,66.866,151.82,70.472,149.593,72.692z"/>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'PencilIcon'
}
</script>
